import { useFormSelector } from 'mrf/redux/ReduxHelper';
import useCurrentUser from 'mrf/utils/useCurrentUser';
import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';
import FormCRUD from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import IFAuth from 'mrf/view/IFAuth';
import TextField from 'mrf/view/TextField';
import { useMemo } from 'react';
import role from 'role';
import PropTypes from 'prop-types';

export default function UserForm({ history, match }) {
    
    const userId = match?.params?.id;

    const currentUser = useCurrentUser();

    const isAdmin = useMemo(() => !!currentUser.roles.find(ur => ur.role.code === 'ADMIN'), [currentUser]);

    const context = useFormSelector({
        id: userId,
        resource: 'users',
        endpoint: `/api/users/${userId}`,
        blankForm: () => isAdmin ? undefined: { countryId: 0 },
    });

    return (
        <FormCRUD
            title='User'
            match={match}
            history={history}
            context={context}
        >
            <Grid>
                <Col size={6}>
                    <TextField
                        label='Username'
                        field='userName'
                        disabled={userId}
                        required
                    />
                </Col>
                <Col size={6}>
                    <TextField
                        label='Full Name'
                        field='fullName'
                        disabled={userId}
                        required
                    />
                </Col>
                <Col size={6}>
                    <TextField
                        type='email'
                        label='Email'
                        field='email'
                        disabled={userId}
                        required
                    />
                </Col>
                <Col size={6}>
                    <TextField
                        label='Phone Number'
                        field='phoneNumber'
                        disabled={userId}
                        required
                    />
                </Col>
                <IFAuth roleCodes={[role.ADMIN]}>
                    <Col size={6}>
                        <FetcherObjectSelect
                            label='Country'
                            resource='countries'
                            displayAttribute='name'
                            field='countryId'
                            required
                        />
                    </Col>
                    <Col size={6}>
                        <FetcherObjectSelect
                            label='Institution'
                            resource='institutions'
                            displayAttribute='name'
                            field='institutionId'
                            required
                        />
                    </Col>
                </IFAuth>
            </Grid>
        </FormCRUD>
    );
}

UserForm.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
};